export default __webpack_public_path__ + "e4dbb6834398bff93a4897c7bf988e51.png";